import pudzianAIBottomGradient from 'assets/images/pudzianAI/pudzianAIBottomGradient.png';
import pudzianAIRegistrationText from 'assets/images/pudzianAI/pudzianAIRegistrationText.svg';
import { DSButton } from 'designSystem/DSButton';
import { AICampaign, AICampaignOption } from 'features/AICampaign/interface';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { addNotification } from 'shared/components/toast';
import { campaignAIConfig } from 'shared/constants/common';
import { AICampaignEvents, setDataLayer } from 'shared/constants/datalayer';

interface Props {
	onClose: () => void;
	verified?: boolean;
	isMojeIdRegistration?: boolean;
	emailVerification?: boolean;
}

export const PudzianAISuccess: FC<Props> = ({ onClose, verified, isMojeIdRegistration = false, emailVerification = false }) => {
	const { t } = useTranslation();

	const handleCampaignSelection = (selectedOption: AICampaignOption) => {
		setDataLayer(AICampaignEvents.DATALAYER_REGISTRATION_CAMPAIGN_SELECTION(selectedOption));

		if (selectedOption !== AICampaign.SKIP) {
			localStorage.setItem(campaignAIConfig.STORAGE_SELECTION_KEY, JSON.stringify({ selectedOption, selectionDate: Date.now() }));
		}

		onClose();
	};

	useEffect(() => {
		if (isMojeIdRegistration) {
			addNotification('success', verified ? t('mojeId_success') : t('mojeId_success_notVerified'));
		} else {
			addNotification('success', emailVerification ? t('registrationFinishByEmailToastText') : t('registrationFinishToastTextActive'));
		}
	}, []);

	return (
		<>
			<div className="fixed z-overlay inset-0 flex flex-col justify-end items-center lg:justify-center h-full w-full" data-theme="light">
				<div className="bg-center bg-[url(assets/images/pudzianAI/pudzianAIHorseMobile.jpg)] md:bg-[url(assets/images/pudzianAI/pudzianAIHorseDesktop.jpg)] md:inset-0 bg-no-repeat bg-cover absolute inset-0 md:bg-top" />
				<img
					src={pudzianAIBottomGradient}
					className="lg:w-1/2 object-cover block absolute z-0 left-0 bottom-0 w-[100vw] object-top max-h-[90%] md:max-h-[80%] lg:max-h-[90%]"
					alt="Gradient background"
				/>
				<img
					src={pudzianAIBottomGradient}
					className="scale-x-[-1] lg:w-1/2 object-cover block absolute z-0 right-0 bottom-0 w-[100vw] object-top max-h-[90%]"
					alt="Gradient background"
				/>
				<div className="pt-4 px-4 pb-8 relative z-3 w-full flex flex-col justify-end items-center lg:top-[10%]">
					<img
						src={pudzianAIRegistrationText}
						alt={t('aiBannerAlt')}
						className="title object-contain w-[351px] md:w-[436px] h-auto block z-1 relative mb-9"
					/>

					<div className="flex flex-col gap-4 max-w-[375px] w-full">
						<div className="flex gap-4">
							<DSButton
								size="medium"
								color="tertiary"
								className="w-1/2"
								onClick={() => handleCampaignSelection(AICampaign.AI)}
								cyTestRef="registration-form"
							>
								{t('ai')}
							</DSButton>
							<DSButton
								size="medium"
								color="tertiary"
								className="w-1/2"
								onClick={() => handleCampaignSelection(AICampaign.INTUITION)}
								cyTestRef="registration-form"
							>
								{t('intuition')}
							</DSButton>
						</div>
						<DSButton
							size="medium"
							color="secondary"
							className="w-full"
							onClick={() => handleCampaignSelection(AICampaign.SKIP)}
							cyTestRef="registration-form"
						>
							{t('skip')}
						</DSButton>
					</div>
				</div>
			</div>
		</>
	);
};
